// extracted by css-extract-rspack-plugin
export default {"TimelineRow":"FileHistory-module__TimelineRow__KPxt4"};